"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var patterns_1 = require("./patterns");
var config_1 = require("./config");
var styles_1 = require("./styles");
var Shapes_1 = __importDefault(require("./Shapes"));
var Background = function (_a) {
    var id = _a.id, className = _a.className, version = _a.version, color = _a.color, _b = _a.noise, noise = _b === void 0 ? false : _b, _c = _a.shapes, shapes = _c === void 0 ? false : _c, _d = _a.contentFocus, contentFocus = _d === void 0 ? 'left' : _d, children = _a.children;
    var config = react_1.default.useMemo(function () { return (version ? config_1.CONFIG[version] : undefined); }, [version]);
    var patternUrl = react_1.default.useMemo(function () {
        return config
            ? patterns_1.PATTERNS(config.patternColor)[config.patternStyle][config.patternDensity]
            : undefined;
    }, [config]);
    return (react_1.default.createElement(styles_1.Wrapper, { "data-component-name": "Background", id: id, className: className, "$backgroundColor": color || (config === null || config === void 0 ? void 0 : config.backgroundColor) },
        config && patternUrl && (react_1.default.createElement(styles_1.Pattern, { "$url": patternUrl, "$gradientColor": config.backgroundColor, "$contentFocus": contentFocus })),
        config && noise && react_1.default.createElement(styles_1.Noise, { "$color": config.gradientColor, "$contentFocus": contentFocus }),
        config && shapes && react_1.default.createElement(Shapes_1.default, { version: config.shapesVersion, contentFocus: contentFocus }),
        react_1.default.createElement(styles_1.Content, null, children)));
};
exports.default = Background;
